import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';

import { Box, Divider, Typography, Grid, Container, Button,
            Paper, CircularProgress, TableRow, TableCell, Table, TableContainer, TableHead, TableBody, } from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import CustomStatusChip from '../../utils/components/CustomStatusChip';
import { getDate } from '../../utils/functions/Utils';

function DetalleMovimiento() {
    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState({
        noSolicitud: '',
        solicitante: '',
        noOrden: '',
        estatus: '',
        recibe: '',
        observaciones: '',
    });

    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([{}]);
    
    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    // get id from url
    let { id } = useParams()

    useEffect(() => {
        if (!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Detalle de movimiento de Inventario';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } });
    }

    useEffect(() => {
        getData();
        return () => { 

        }
   }, [])

    const getData = async () => {
        setLoading(true);
        try {
            let res = await axios.get(`/api/inventories/${id}`);
            if(res.status === 200) {
                setData(res.data);
                setProducts(res.data.productos);
            }
            setLoading(false);

        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al cargar la solicitud de salida de almacén, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
            setLoading(false);
        }
    }

    const renderMovimiento = () => {
        if(data.tipoMovimiento === 'entrada') {
            return(
                <Container maxWidth='xl' sx={{ backgroundColor: 'comp.boxBg', padding: '12px', borderRadius: '20px', borderColor: 'comp.boxBorder'}} >
                    <Divider className='my-4' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Entrada' className='text-bold' />
                    </Divider>

                    <Grid container>
                        <Grid item sm={12} md={6}>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Fecha de entrada:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{getDate(data.entrada.fechaDeEntrada, 'DDDD ')}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}># Factura:</TableCell>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor1'}} className='text-bold'>{data.entrada.noFactura ? data.entrada.noFactura : ''}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Recibe:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.entrada.recibe ? data.entrada.recibe : ''}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item sm={12} md={6}>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Entrega:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.entrada.entrega ? data.entrada.entrega : ''}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Proveedor:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.entrada.proveedor ? data.entrada.proveedor : ''}</TableCell>
                                        </TableRow>
                                        {
                                            data.entrada.devolucion ? 
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Devolucion:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{`# Cotizacion: ${data.entrada.infoDevolucion.noSolicitud} - ${data.entrada.infoDevolucion.observaciones}`}</TableCell>
                                            </TableRow> : <></>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>

                    <p></p>
                </Container>
            )
        } else {
            return (
                <Container maxWidth='xl' sx={{ backgroundColor: 'comp.boxBg', padding: '12px', borderRadius: '20px', borderColor: 'comp.boxBorder' }} >
                    <Divider className='my-4' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Salida' className='text-bold' />
                    </Divider>

                    <Grid container>
                        <Grid item sm={12} md={6}>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Fecha de salida:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{getDate(data.salida.fechaDeSalida, 'DDDD ')}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}># Vale de Salida:</TableCell>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor1'}} className='text-bold'>{data.salida.noValeSalida ? data.salida.noValeSalida : ''}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Solicitante:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.salida.solicitante ? data.salida.solicitante : ''}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Recibe:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.salida.recibe ? data.salida.recibe : ''}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item sm={12} md={6}>
                            <TableContainer>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Entrega:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.salida.entrega ? data.salida.entrega : ''}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}># Cotizacion:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.salida.noOrden ? data.salida.noOrden : ''}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Cliente:</TableCell>
                                            <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.salida.cliente ? data.salida.cliente : ''}</TableCell>
                                        </TableRow>
                                        {
                                            data.salida.servicio ? 
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Servicio:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{`# Reporte: ${data.salida.infoServicio.noReporte} - ${data.salida.infoServicio.hospital}`}</TableCell>
                                            </TableRow> : <></>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>

                    <p></p>
                </Container>
            )
        }
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

            {loading ?
                <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                    <CircularProgress size='5em' color='primary' />
                </Box> :

                    <Paper sx={{ padding: '24px' }} elevation={3}>
                        <Box className='text-center' >
                            <Typography variant='h5' style={{ fontWeight: 700 }}>Detalle de movimiento de Inventario</Typography>
                        </Box>
                        
                        <Container maxWidth='xl' sx={{mb:2}}>
                            <Button size='small' variant='outlined' onClick={() => navigate('/inventario/tablaInventario')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                        </Container>
                        
                        <Container maxWidth='xl' sx={{backgroundColor: 'comp.boxBg', padding: '12px', borderRadius: '20px', borderColor: 'comp.boxBorder'}} >
                            
                            
                            <Divider className='my-4' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Detalles del movimiento' className='text-bold' />
                            </Divider>

                            <Grid container>
                                <Grid item sm={12} md={6}>
                                    <TableContainer>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}># Movimiento:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.noMovimiento ? data.noMovimiento : ''}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Tipo de Movimiento:</TableCell>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor1'}} className='text-bold'>
                                                        <CustomStatusChip label={data.tipoMovimiento ? data.tipoMovimiento : ''} estatus={data.tipoMovimiento ? data.tipoMovimiento : ''}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Operación:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.operacion ? data.operacion : ''}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Motivo:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>
                                                        <CustomStatusChip label={data.motivo ? data.motivo : ''} estatus={data.motivo ? data.motivo : ''}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Fecha de movimiento:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.entrada ? getDate(data.entrada.fechaDeEntrada, 'DDDD ') : getDate(data.salida.fechaDeSalida, 'DDDD')}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <TableContainer>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Descripción:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.descripcion ? data.descripcion : ''}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Estatus:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>
                                                        <CustomStatusChip variant='outlined' label={data.estatus ? data.estatus : ''} estatus={data.estatus ? data.estatus : ''}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Observaciones:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.observaciones ? data.observaciones : ''}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Autoriza:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{data.auth ? data.auth : ''}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>

                            <p></p>
                        </Container>
                        <br />

                        {renderMovimiento()}
                        

                        <Container maxWidth={'xl'}>
                            <Grid container>
                                <Grid item sm={12}>
                                    <Divider className='my-4' textAlign="left">
                                        <CustomChip variant='outlined' estatus='ATENDIDO' label='Productos' className='text-bold' />
                                    </Divider>

                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow hover >
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#47A99222' }} colSpan={4}>Detalles</TableCell>
                                                </TableRow>
                                                <TableRow hover sx={{backgroundColor: 'comp.tableHeaderBg'}}>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cantidad</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Descripcion</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {products.map((ref, i) => (
                                                    <TableRow hover key={i} sx={{backgroundColor: 'comp.tableBg'}}>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.descripcion}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <br />
                                </Grid>               
                            </Grid>
                        </Container>
                    </Paper>
            }

            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            
        </Container>
    );
}

export default DetalleMovimiento;